import type { HbBidderConfig } from '../types'

// Nexxen (Unruly): the IBV site may only receive slots that support in-banner video.
export const UNRULY: HbBidderConfig = {
    bidder: 'unruly',
    params: ({ adSource, mediaTypes }) => {
        if (adSource !== 'portal') {
            return undefined
        }

        const allowsInBannerVideo = mediaTypes?.banner && mediaTypes.video?.context === 'outstream'
        return { siteId: allowsInBannerVideo ? 306360 : 306359 }
    },
}
